import { render, staticRenderFns } from "./messagePosTable.vue?vue&type=template&id=27d635f4"
import script from "./messagePosTable.vue?vue&type=script&lang=js"
export * from "./messagePosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports